<a *ngIf="user" href="#" [matMenuTriggerFor]="menuUser" onclick="return false">
  <img [src]="user.avatar" alt="" class="nav-menu__image">
</a>
<mat-menu #menuUser="matMenu" [class]="'brn-menu'">
  <a [href]="portalSettings.url + '/profile'" mat-menu-item class="user-menu__item">
    {{user?.name}}
    <br>
    <small>{{user?.email}}</small>
  </a>
  <a [href]="location.prepareExternalUrl('auth/logout')" class="user-menu__logout">
    <mat-icon>exit_to_app</mat-icon>
  </a>
</mat-menu>
